/// <reference path="../types.js" />

function ensureCritical(element) {
  element.data = { ...(element.data || {}), criticalPath: true };
}

/**
 * Marca recursivamente os elementos do caminho crítico replicando a lógica
 * original utilizada pelo fluxo.
 * @param {string} itemId
 * @param {Elements} elements
 * @returns {Elements}
 */
export function recursionCritical(itemId, elements) {
  const newElements = JSON.parse(JSON.stringify(elements));

  for (let index = 0; index < newElements.length; index += 1) {
    const element = newElements[index];

    if (element.id !== itemId) {
      continue;
    }

    ensureCritical(element);

    if (!element.source) {
      for (let i = 0; i < newElements.length; i += 1) {
        const current = newElements[i];

        if (
          current.source === itemId &&
          !newElements.find(
            (item) =>
              item.source === itemId && item.data?.criticalPath === true
          )
        ) {
          if (
            newElements.filter((item) => item.source === itemId).length > 1
          ) {
            const hasMarkedTarget = newElements.find(
              (item) =>
                current.target === item.id && current.data?.criticalPath === true
            );

            if (hasMarkedTarget) {
              ensureCritical(current);
              return recursionCritical(current.id, newElements);
            }
          } else {
            ensureCritical(current);
            return recursionCritical(current.id, newElements);
          }
        } else if (
          current.target === itemId &&
          !newElements.find(
            (item) =>
              item.target === itemId && item.data?.criticalPath === true
          )
        ) {
          if (
            newElements.filter((item) => item.target === itemId).length > 1
          ) {
            const hasMarkedSource = newElements.find(
              (item) =>
                current.source === item.id && current.data?.criticalPath === true
            );

            if (hasMarkedSource) {
              ensureCritical(current);
              return recursionCritical(current.id, newElements);
            }
          } else {
            ensureCritical(current);
            return recursionCritical(current.id, newElements);
          }
        }
      }
    } else {
      for (let i = 0; i < newElements.length; i += 1) {
        const current = newElements[i];

        if (current.id === element.source || current.id === element.target) {
          if (current.data?.criticalPath !== true) {
            ensureCritical(current);
            return recursionCritical(current.id, newElements);
          }
        }
      }
    }
  }

  return newElements;
}
